import { createContext, useContext } from 'react';

// CROW has a single light identity (see the B2 design spec §4).
// This provider is retained only so existing `useTheme()` imports keep
// working during the migration; it is deleted in Plan 3.
const ThemeContext = createContext({ theme: 'light' });

export function ThemeProvider({ children }) {
  return (
    <ThemeContext.Provider value={{ theme: 'light' }}>
      <div className="bg-surface-page min-h-screen">{children}</div>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
